import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createStore } from 'zustand/vanilla';
export function useFollowUps() {
    const [selections, setSelections] = useState([]);
    const [interaction] = useState(() => createStore(() => ({ hoveredId: null, navigation: null })));
    const timer = useRef(undefined);
    useEffect(() => () => clearTimeout(timer.current), []);
    const reset = useCallback((next = []) => {
        setSelections(next);
        clearTimeout(timer.current);
        interaction.setState({ hoveredId: null, navigation: null });
    }, [interaction]);
    return useMemo(() => ({
        selections,
        interaction,
        reset,
        hover: (hoveredId) => interaction.setState({ hoveredId }),
        add: (quote) => setSelections((current) => [...current, quote]),
        remove: (id) => {
            setSelections((current) => current.filter((quote) => quote.id !== id));
            interaction.setState(({ hoveredId, navigation }) => ({
                hoveredId: hoveredId === id ? null : hoveredId,
                navigation: navigation?.id === id ? null : navigation,
            }));
        },
        navigate: (id) => {
            clearTimeout(timer.current);
            interaction.setState({ hoveredId: null, navigation: { id, pending: true } });
        },
        finishNavigation: (id) => {
            // Don't replay this scroll after the answer remounts.
            if (interaction.getState().navigation?.id !== id)
                return;
            interaction.setState({ navigation: { id, pending: false } });
            clearTimeout(timer.current);
            timer.current = setTimeout(() => interaction.setState({ navigation: null }), 3000);
        },
    }), [selections, interaction, reset]);
}
//# sourceMappingURL=useFollowUps.js.map